import { type MouseEvent, type PointerEvent, useRef, useState } from 'react'

/**
 * A touch screen has no hover: there a tap on the trigger opens the tooltip and the next
 * tap closes it. Mouse and keyboard keep the tooltip's own behaviour. Pass `open` and
 * `onOpenChange` to the Tooltip and spread `trigger` on the element inside TooltipTrigger.
 */
export function useTapTooltip() {
  const [open, setOpen] = useState(false)
  const touch = useRef<{ wasOpen: boolean } | null>(null)
  return {
    open,
    onOpenChange: setOpen,
    trigger: {
      onPointerDown: (event: PointerEvent<HTMLElement>) => {
        touch.current = event.pointerType === 'touch' ? { wasOpen: open } : null
      },
      onClick: (event: MouseEvent<HTMLElement>) => {
        if (!touch.current) return
        // keeps the trigger's own close-on-click from undoing the tap
        event.preventDefault()
        setOpen(!touch.current.wasOpen)
      },
    },
  }
}
